import UserListRoute from './UserListRoute';

export default UserListRoute;
